import React from "react";
import { IppStatsMask } from "../__masks__/IppStats/ippStats";
import {
  PastPerformanceStats,
  IppStatsMaskContainer,
  Title,
  Status,
  StatusItem,
  StatusKey,
  StatusValue
} from "./styled-components";

type Props = {
  isLoading: boolean;
  title?: string;
  races: string | number;
  wins: string | number;
  top3: string | number;
};

const PastPerformanceStatus = ({
  isLoading,
  title,
  races,
  wins,
  top3
}: Props) => (
  <PastPerformanceStats>
    {title && <Title>{title}</Title>}
    {isLoading ? (
      <IppStatsMaskContainer>
        <IppStatsMask />
      </IppStatsMaskContainer>
    ) : (
      <Status>
        <StatusItem>
          <StatusKey>Starts</StatusKey>
          <StatusValue>{races}</StatusValue>
        </StatusItem>
        <StatusItem>
          <StatusKey>Wins</StatusKey>
          <StatusValue perfectStatus={wins === 100}>{wins}%</StatusValue>
        </StatusItem>
        <StatusItem>
          <StatusKey>TOP3</StatusKey>
          <StatusValue perfectStatus={wins === 100}>{top3}%</StatusValue>
        </StatusItem>
      </Status>
    )}
  </PastPerformanceStats>
);

PastPerformanceStatus.defaultProps = {
  isLoading: true,
  title: null,
  races: 0,
  wins: 0,
  top3: 0
};

export default PastPerformanceStatus;
